export default {"src":"/_next/static/media/controlled-usage.1f4bfcd9.svg","height":512,"width":640,"blurWidth":0,"blurHeight":0};